import { render, staticRenderFns } from "./imgbox.vue?vue&type=template&id=6a1a319a&scoped=true&lang=pug&"
import script from "./imgbox.vue?vue&type=script&lang=js&"
export * from "./imgbox.vue?vue&type=script&lang=js&"
import style0 from "./imgbox.vue?vue&type=style&index=0&id=6a1a319a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a319a",
  null
  
)

export default component.exports